import React from 'react'
import {
  LinkedinShareButton,
  FacebookShareButton,
  RedditShareButton,
  WhatsappShareButton
} from "react-share";

function BlogHeader({BlogStamp,BlogTitle,BlogMinutes}) {
  return (
    <div>
        <p>Blog Post Published On {BlogStamp}</p>
        <h1>{BlogTitle}</h1>
        <p>{BlogMinutes}</p>
        <div id='blogtop'>
        <div id='authorinfo'>
            {/* <div className='profile-image'>
                <img src="https://frontend-resource.s3.ap-south-1.amazonaws.com/profile_picture.png" alt="Profile Image" title='Profile picture of writer'/>
            </div> */}
            <div>
                <p>By Rohit Kumar<br/>
                Co-Founder, LexiTrove</p>
            </div>
        </div>
        <div>
        <p>Share This Post</p>
        <div className='icon'>
        <LinkedinShareButton url={"https://www.lexitrove.com/blog/Beyond-the-April-Horizon-What-ERA-2025-Demands-of-Employment-Practitioners-Right-Now"} source={'LexiTrove'}><i class="fa-brands fa-linkedin fa-lg"></i></LinkedinShareButton> <FacebookShareButton url={"https://www.lexitrove.com/blog/Beyond-the-April-Horizon-What-ERA-2025-Demands-of-Employment-Practitioners-Right-Now"}><i class="fa-brands fa-square-facebook fa-lg"></i></FacebookShareButton> <RedditShareButton url={"https://www.lexitrove.com/blog/Beyond-the-April-Horizon-What-ERA-2025-Demands-of-Employment-Practitioners-Right-Now"}><i class="fa-brands fa-square-reddit fa-lg"></i></RedditShareButton> <WhatsappShareButton url={"https://www.lexitrove.com/blog/Beyond-the-April-Horizon-What-ERA-2025-Demands-of-Employment-Practitioners-Right-Now"}><i class="fa-brands fa-square-whatsapp fa-lg"></i></WhatsappShareButton>
        </div><br/>
        </div>
        </div>
        <hr/>
        <div>
        </div>
    </div>
  )
}

export default BlogHeader